import { SET_GENERAL_SETTING_STATUS_PIN } from "../../assets/constants/reducer.type";

export const setStatusPin = (payload) => {
  return { type: SET_GENERAL_SETTING_STATUS_PIN, payload };
};
